import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { IconDefinition } from 'src/components/Icon';
import { PlatformTab } from 'src/models/platform/_types';
interface DecoratedNavItem extends PlatformTab {
  reactRoute?: string;
  icon?: IconDefinition;
  children?: DecoratedNavItem[];
  target?: string;
}

export const useAdminNav = (): DecoratedNavItem[] => {
  return [
    {
      id: 'platforms',
      name: 'Platforms',
      route: '',
      reactRoute: '/admin/platform',
      icon: icon({ name: 'building', style: 'regular' }),
      enabled: true,
    },
    {
      id: 'users',
      name: 'Users',
      route: '',
      reactRoute: '/admin/user',
      icon: icon({ name: 'users', style: 'regular' }),
      enabled: true,
    },
    {
      id: 'emails',
      name: 'Emails',
      icon: icon({ name: 'envelope', style: 'regular' }),
      route: '',
      reactRoute: '/emails',
      enabled: true,
    },
    {
      id: 'utilities',
      name: 'Utilities',
      route: '',
      reactRoute: '/admin/utilities/update_twilio_numbers',
      icon: icon({ name: 'wrench', style: 'regular' }),
      enabled: true,
      children: [
        {
          id: 'twilio',
          name: 'Twilio Numbers',
          route: '',
          reactRoute: '/admin/utilities/update_twilio_numbers',
          enabled: true,
        },
        {
          id: 'hello-bar',
          name: 'Hello Bar',
          route: '',
          reactRoute: '/admin/utilities/hello-bar',
          enabled: true,
        },
      ],
    },
  ];
};
